<template>
    <div class="page-not-found">
        <h1>Página no encontrada</h1>
    </div>
</template>
<script>
export default {
    
}
</script>